import { styled, Typography } from '@mui/material';

function InscriptionSuccess() {
    return (
        <Container>
            <Title variant="h1">Demande d'inscription envoyée</Title>
            <Typography variant="h2">
                Merci, votre demande a bien été prise en compte. Le service Formation continue vous
                contactera bientôt.
            </Typography>
            <Typography variant="h2">
                Si vous avez la moindre question, n'hésitez pas à nous écrire à
                formationcontinue@esaj.asso.fr
            </Typography>
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
    padding: theme.spacing(8),
    textAlign: 'center',
}));
const Title = styled(Typography)(({ theme }) => ({
    marginBottom: theme.spacing(2),
}));

export { InscriptionSuccess };
